module.exports = __webpack_public_path__ + "img/7-2.bae60341.svg";